import { useEffect } from "react";
import { API } from "@/lib/api";
import { cid } from "@/components/LikeButton";

const CAP = 1800;

// Counts on-screen reading time and deepest scroll for an article, sent when the reader leaves.
export function useReadTracking(slug: string | undefined, enabled: boolean, testId = "blog-post-page") {
  useEffect(() => {
    if (!slug || !enabled) return;
    let seconds = 0, depth = 0, sent = 0;
    const tick = window.setInterval(() => { if (!document.hidden && seconds < CAP) seconds += 1; }, 1000);
    const measure = () => {
      const el = document.querySelector(`[data-testid="${testId}"]`) as HTMLElement | null;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const seen = Math.min(r.height, Math.max(0, window.innerHeight - r.top));
      depth = Math.max(depth, Math.round((100 * seen) / Math.max(1, r.height)));
    };
    const send = () => {
      if (seconds === sent || seconds < 2) return;
      sent = seconds;
      const blob = new Blob([JSON.stringify({ cid: cid(), seconds, depth: Math.min(100, depth) })], { type: "application/json" });
      if (!navigator.sendBeacon?.(`${API}/blog/${slug}/read`, blob)) fetch(`${API}/blog/${slug}/read`, { method: "POST", body: blob, keepalive: true, headers: { "Content-Type": "application/json" } }).catch(() => {});
    };
    const onHide = () => { if (document.hidden) send(); };
    const first = window.setTimeout(measure, 500);
    window.addEventListener("scroll", measure, { passive: true });
    document.addEventListener("visibilitychange", onHide);
    window.addEventListener("pagehide", send);
    return () => {
      send();
      window.clearInterval(tick); window.clearTimeout(first);
      window.removeEventListener("scroll", measure);
      document.removeEventListener("visibilitychange", onHide);
      window.removeEventListener("pagehide", send);
    };
  }, [slug, enabled, testId]);
}
